<template>
  <div class="orders-main-view">
    <modal
      ref="loading"
      template="loading"
      title="Aguarde"
      ref-name="loading"
    >
      <p>Salvando alterações.</p>
    </modal>
    <modal
      ref="deleteModal"
      template="question"
      ref-name="deleteModal"
      first-button-text="Cancelar"
      second-button-text="Excluir"
      :close-button-enabled="true"
      @first-cta="closeConfirmDeleteOrder"
      @second-cta="deleteSelectedOS"
    >
      <p>Deseja excluir as OS's selecionadas?</p>
    </modal>

    <modal
      ref="deleteIncorrectsModal"
      template="question"
      ref-name="deleteIncorrectsModal"
      first-button-text="Cancelar"
      second-button-text="Excluir"
      :close-button-enabled="true"
      @first-cta="closeDeleteIncorrectsModal"
      @second-cta="deleteIncorrectOSs"
    >
      <p>Deseja excluir as {{ errorOrders }} OS's incorretas?</p>
    </modal>

    <subheader
      id="samples-main-view-subheader"
      class="alternative-subheader"
    >
      <div slot="filter-labels">
        <div
          id="btnPrintTagFilter"
          @click="setOrderShowOff(true)"
        >
          <h2>
            <span id="titleOrder">Listagem de Ordens de Serviço:</span>
            <span
              v-for="(filterLabel, index) in filterLabels"
              :key="filterLabel"
            ><span class="filter-labels">{{ filterLabel }}</span><span v-if="index + 1 < filterLabels.length">, </span>
            </span>
          </h2>
        </div>
      </div>
      <div class="subheader-alternative-actions-container">
        <div
          class="subheader-actions-container__turn-back position-right"
          @click="setOrderShowOff(true)"
        >
          <md-icon
            id="backToSearch"
            md-src="/static/images/icon-back-to-search.svg"
          />
        </div>
        <button
          id="BtnOrdersNew"
          class="btn btn-primary btn-regular-size"
          @click="$router.push('/orders/new')"
        >
          <md-icon md-src="/static/images/icon-add.svg" />CADASTRAR OS
        </button>
        <button
          id="BtnOrdersSend"
          :disabled="!hasOrders"
          class="btn btn-primary btn-regular-size"
          @click="transferAllOrders()"
        >
          <md-icon md-src="/static/images/icon-send.svg" />TRANSFERIR
          <span v-if="orderSelected.length > 0">({{ orderSelected.length }})</span>
        </button>
        <br>
      </div>
      <div class="subheader-alternative-actions-container subheader-actions-search">
        <transition name="fade">
          <button
            v-if="orderSelected.length > 0 && !tranferingAllWithoutSelecting"
            id="BtnDeleteOrders"
            :disabled="!hasOrders"
            class="btn btn-regular-size btn-quinternary orders-list-bar__btn-delete"
            @click="controlsOpenModalWithDeletetion"
          >
            <md-icon
              md-src="/static/images/icon-delete.svg"
              class="orders-list-bar__btn-delete__icon"
            >
              delete
            </md-icon>Excluir
            <span>({{ orderSelected.length }})</span>
          </button>
        </transition>

        <document-filter
          :loading="loading"
          :total-exams-pending="totalOrdersExamsWithDocumentsPending"
        />
      </div>
    </subheader>

    <orders-summary />

    <md-dialog
      id="modDashboardComponents"
      ref="termsTransferModal"
      md-title
      :md-click-outside-to-close="true"
      class="transfer-terms-modal modals medium-modal"
      @close="reloadOSList()"
    >
      <md-dialog-title>
        <span class="main-title">
          <md-icon
            class="icon-doc-title"
            md-src="/static/images/icon-document-file.svg"
          />
          Termo de responsabilidade
        </span>
        <button
          id="mod_btnCloseSpinner"
          class="close-button btn-transparent"
          @click="closedTransferTermsModal()"
        >
          <md-icon>clear</md-icon>
        </button>
      </md-dialog-title>

      <md-dialog-content>
        <transfer-terms-modal
          :order-selected="orderSelected"
          @openTransfer="validateBeforeTransfering"
          @closeModal="closedTransferTermsModal"
          @transferOs="transferFromPatientView"
        />
      </md-dialog-content>
    </md-dialog>

    <md-dialog
      id="modDashboardComponents"
      ref="transferModal"
      md-title
      :md-esc-to-close="!spinnerLoading"
      :md-click-outside-to-close="false"
      class="transfer-modal modals"
      :class="{'larger-modal': !isSpinnerEnabled}"
      @close="reloadOSList()"
    >
      <md-dialog-title>
        <span
          v-if="transfering"
          class="main-title"
        >
          {{ modalTransferingTitle }}
        </span>
        <button
          v-if="!spinnerLoading"
          id="mod_btnCloseSpinner"
          class="close-button btn-transparent"
          @click="closedTransferModal()"
        >
          <md-icon>clear</md-icon>
        </button>
      </md-dialog-title>

      <md-dialog-content
        v-if="transfering"
        class="md-dialog-content-spinner"
      >
        <div v-if="isSpinnerEnabled">
          <spinner-progress
            :key="spinnerKey"
            :order-selected="orderSelected"
            :is-modal-open="isTransferModalOpen"
            :closed-transfer-modal="closedTransferModal"
            :is-loading.sync="spinnerLoading"
            :modal-title.sync="modalTransferingTitle"
            :exam-type="examOrderType"
            :patient-link="patientLink"
          />
        </div>
        <div v-else>
          <p>Transferindo OS selecionadas...</p>
          <progress-bar
            v-if="transfering"
            :progress="progress"
          />
        </div>
      </md-dialog-content>

      <md-dialog-content v-else>
        <orders-main-view
          :close-all-batches="closeAllBatches"
          :start-transfer="startTransfer"
        />
      </md-dialog-content>
    </md-dialog>
    
    <orders-list
      v-if="hasOrders || loading"
      :selected.sync="orderSelected"
      class="width-responsiveness"
      :reset-select-list-for-individual-transfer="resetSelectListForIndividualTransfer"
      :reload="reload"
      @transferingOsFromPatientView="validateConsentForm"
    />
    
    <div
      v-else
      class="empty-cart"
    >
      <img
        src="/static/images/icon-empty-cart.svg"
        alt="Nenhuma OS encontrada."
      >
      <h2>Nenhuma OS encontrada.</h2>
      <p>Para adicionar OS, selecione:</p>
      <div class="actions">
        <md-button
          id="btnEmptyCartUploadXML"
          class="btn btn-secondary"
          @click="performUpload"
        >
          Fazer Upload de XML
        </md-button>
        <md-button
          id="btnEmptyCartNewOrder"
          class="btn btn-secondary"
          @click="$router.push('/orders/new')"
        >
          CADASTRAR OS
        </md-button>
        <br>
      </div>
    </div>

    <snackbar
      ref="incorrectOsAlert"
      md-position="bottom center"
      ref-name="incorrectOsAlert"
      md-duration="9999999"
      class="snackbar-red"
      first-button-text="Não, ignorar"
      second-button-text="Sim, excluir incorretas"
      @first-cta="closeSnackbar"
      @second-cta="openDeleteIncorrectsModal"
    >
      Existem
      <strong>{{ errorOrders }}</strong> OS's incorretas na listagem. Deseja excluí-las?
    </snackbar>
  </div>
</template>

<script>
import OrdersList from './OrdersList'
import Snackbar from '@/components/Snackbar/Snackbar'
import SubHeader from '../common/SubHeader'
import OrdersSummary from './OrdersSummary'
import TransferTermsModal from './TransferTermsModal'
import { mapActions, mapGetters } from 'vuex'
import notify from '@/api/notification'
import strings from '@/strings'
import ProgressBar from '../common/ProgressBar'
import orderService from '@/api/order'
import SpinnerProgress from '../common/transfer/SpinnerProgress'
import { resetSortSvgStatus } from '@/utils/sort-columns'
import DocumentFilter from '../Documents/Laboratory/Filter'
import { formatDate } from '@/utils/date-utils'

import {
  ORDER_STATE_RECEIVED,
  ORDER_STATE_VALIDATED,
  ORDER_STATUS_ERROR,
  ORDER_SEARCH_BY_RECOLLECT
} from '@/enums'

const NO_TRANSMITTABLE_OS = 'Não há OSˊs passíveis de transferência.'
const DELETED_OS = 'Ordens de serviços excluídas com sucesso'
const DELETED_INCORRECT_OS = "OS's incorretas excluídas com sucesso"

export default {
  name: 'Orders',
  components: {
    'orders-list': OrdersList,
    'transfer-terms-modal': TransferTermsModal,
    subheader: SubHeader,
    'orders-summary': OrdersSummary,
    'progress-bar': ProgressBar,
    'spinner-progress': SpinnerProgress,
    'document-filter': DocumentFilter,
    'snackbar': Snackbar
  },
  data: () => ({
    orderSelected: [],
    transfering: true,
    filterOptions: strings.filterOS,
    progress: 0,
    timeout: undefined,
    pendingOs: 0,
    isTransferModalOpen: false,
    modalTransferingTitle: 'Aguarde',
    spinnerLoading: true,
    incorrectOrders: [],
    tranferingAllWithoutSelecting: false,
    filterLabels: [],
    spinnerKey: 0,
    examOrderType: null
  }),
  created () {
    this.checkPendingTransferOS()
  },
  methods: {
    ...mapActions(['clearAllOrderData']),
    ...mapActions(['performTransferOs']),
    ...mapActions(['performTransferOsSpinner']),
    ...mapActions(['showMessage']),
    ...mapActions(['selectOSList']),
    ...mapActions(['deleteSelectedOrders']),
    ...mapActions(['getTotalOrder']),
    ...mapActions(['setOrderShowOff']),
    ...mapActions(['setUploadModalVisible']),
    ...mapActions(['countTotalOrdersWithDocPending']),
    reload () {
      window.location.reload()
      resetSortSvgStatus()
    },
    performUpload () {
      this.setUploadModalVisible(true)
    },
    incrementProgress () {
      let totalOS = this.orderSelected.length
      this.osTime = totalOS * 5 * 10
      if (this.osTime <= 100) {
        this.osTime = 80
      } else if (this.osTime >= 600) {
        this.osTime = 590
      } else if (this.osTime >= 400) {
        this.osTime = this.osTime - 65
      } else {
        this.osTime = this.osTime - 70
      }
      this.timeout = setTimeout(() => {
        this.progress++
        if (this.progress < 100) {
          this.incrementProgress()
        }
      }, this.osTime)
    },
    transferAllOrders () {
      if (
        this.toggle.consentForm &&
        this.orders
          .filter(order => this.orderSelected.length ? this.orderSelected.includes(order.id) : true)
          .some(order => order.exams.some(exam => exam.exam_sent === 'SEXA'))
      ) {
        this.examOrderType = 'SEXA'
        this.selectAllOrders()
        this.$refs.termsTransferModal.open()
      } else {
        this.validateBeforeTransfering()
      }
    },
    validateConsentForm (os) {
      if (
        this.toggle.consentForm &&
        this.orders
          .filter(order => order.id === os)
          .some(order => order.exams.some(exam => exam.exam_sent === 'SEXA'))
      ) {
        this.examOrderType = 'SEXA'
        this.openTransferTermsModal(os)
      } else if (this.orders.some(order => order.id === os)) {
        this.transferFromPatientView(os)
      } else {
        this.validateBeforeTransfering()
      }
    },
    openTransferTermsModal (os) {
      this.orderSelected = []
      this.orderSelected.push(os)
      this.$refs.termsTransferModal.open()
    },
    closedTransferTermsModal () {
      this.$refs.termsTransferModal.close()
    },
    async validateBeforeTransfering () {
      this.tranferingAllWithoutSelecting = true
      await this.checkPendingTransferOS()

      if (this.orderSelected.length === 0) {
        this.selectAllOrders()
      }

      if (this.orderSelected.length > 0) {
        this.startTransfer()
      } else {
        this.showMessage(NO_TRANSMITTABLE_OS)
      }
    },
    selectAllOrders () {
      this.orders.filter(item => {
        if (this.orderCanBeTransmitted(item)) {
          this.orderSelected.push(item.id)
        }
      })
    },
    orderCanBeTransmitted (order) {
      let orderIncorrectReceived = order.state !== ORDER_STATE_RECEIVED
      let orderIncorrectStatus = order.status !== ORDER_STATUS_ERROR
      let orderInValidatedState = order.state === ORDER_STATE_VALIDATED
      return (
        orderInValidatedState &&
        orderIncorrectStatus &&
        orderIncorrectReceived
      )
    },
    startTransfer () {
      this.transfering = true
      if (!this.isSpinnerEnabled) {
        // Modal de transferência: barra fake
        this.performTransferOs(this.orderSelected)
        this.openTransferModal()
        this.incrementProgress()
        this.submitEventForAnalytics('Modal de transferência: barra fake')
      } else {
        // Modal de transferência: spinner
        this.performTransferOsSpinner(this.orderSelected).then(() => {
          this.openTransferModal()
        })
        this.submitEventForAnalytics('Modal de transferência: spinner')
      }
      this.submitEventForAnalytics('Transferir OS - Seleção')
    },
    closedTransferModal () {
      this.$refs.transferModal.close()
      this.$refs.termsTransferModal.close()
    },
    openTransferModal () {
      this.spinnerKey += 1
      this.$refs.transferModal.open()
      this.isTransferModalOpen = true
    },
    deleteSelectedOS () {
      this.closeConfirmDeleteOrder()
      this.openLoadingModal()
      orderService
        .deleteSelectedOrders(this.orderSelected)
        .then(response => {
          this.deleteRows()
          this.showMessage(DELETED_OS)
          this.orderSelected.length = 0
          this.closeLoadingModal()
        })
        .catch(() => {
          this.closeLoadingModal()
        })
      this.$analytics.pushAnalyticsEvent('ga-event', {
        'category': 'Listagem de OS - Listagem',
        'action': 'Excluir OS',
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    },
    reloadOSList () {
      this.clearAllOrderData()
      this.orderSelected = []
      this.transfering = true
      this.spinnerLoading = true
      resetSortSvgStatus()
    },
    deleteRows () {
      var i = this.orderSelected.length
      i = i - 1
      var index
      for (i; i >= 0; i--) {
        index = this.orders.findIndex(x => x.id === this.orderSelected[i])
        this.orderSelected.length = this.orderSelected.length - 1
        this.deleteSelectedOrders(index)
      }
    },
    checkPendingTransferOS () {
      return orderService
        .countOsTransmitting()
        .then((response) => {
          if (response.status === 200) {
            this.pendingOs = response.data.ordersTransmittingCount
          }
        })
        .catch(() => {
          this.pendingOs = 1
        })
    },
    resetSelectListForIndividualTransfer () {
      this.resetSelectList()
    },
    resetSelectList () {
      let checkAllElement = document.getElementById('checkOrderSelectAllElement')
        .checked
      if (checkAllElement === true) {
        document.getElementById('checkOrderSelectAllElement').click()
      }
      this.orderSelected.length = 0
      this.orderSelected = []
    },
    openSnackbar () {
      this.$refs.incorrectOsAlert.open()
    },
    closeSnackbar () {
      this.$refs.incorrectOsAlert.close()
    },
    getIncorrectOrders () {
      this.incorrectOrders = this.orders.reduce(function (filtered, elem) {
        if (elem.status === ORDER_STATUS_ERROR) {
          filtered.push(elem.id)
        }
        return filtered
      }, [])
    },
    deleteIncorrectOSs () {
      this.closeDeleteIncorrectsModal()
      this.openLoadingModal()
      this.getIncorrectOrders()
      orderService
        .deleteSelectedOrders(this.incorrectOrders)
        .then(response => {
          this.showMessage(DELETED_INCORRECT_OS)
          this.incorrectOrders = []
          this.reloadOSList()
          this.closeLoadingModal()
        })
        .catch(() => {
          this.closeLoadingModal()
        })
    },
    openDeleteIncorrectsModal () {
      this.$refs.deleteIncorrectsModal.open()
    },
    closeDeleteIncorrectsModal () {
      this.$refs.deleteIncorrectsModal.close()
    },
    showHideSnackBarValidator () {
      if (this.errorOrders > 1) {
        this.openSnackbar()
      } else {
        this.closeSnackbar()
      }
    },
    buildFilterLabel () {
      this.filterLabels = []
      let isFiltersEmpty = Object.keys(this.$route.query).length === 0

      if (isFiltersEmpty) {
        this.filterLabels.push('todas')
      }

      if (this.$route.query.filterBy) {
        let filterBy
        let isFiltersAnArray = Array.isArray(this.$route.query.filterBy)
        let isAllFiltersSelected = this.$route.query.filterBy.length === strings.filterOS.length
        let isSomeFiltersSelected = this.$route.query.filterBy.length < strings.filterOS.length

        if (isFiltersAnArray && isAllFiltersSelected) {
          this.filterLabels.push('todas')
        } else if (isFiltersAnArray && isSomeFiltersSelected) {
          for (var i = 0; i < this.$route.query.filterBy.length; i++) {
            filterBy = strings.filterOS.filter(item => item.value === this.$route.query.filterBy[i])[0]
            if (filterBy) {
              if (filterBy.labelVisible) {
                this.filterLabels.push(filterBy.label)
              }
            }
          }
        } else {
          filterBy = strings.filterOS.filter(item => item.value === this.$route.query.filterBy)[0]
          if (filterBy) {
            if (filterBy.labelVisible) {
              this.filterLabels.push(filterBy.label)
            }
          }
        }
      }

      if (this.$route.query.findTypeOrderResultFilter === ORDER_SEARCH_BY_RECOLLECT) {
        this.filterLabels.push('gerada via recoleta')
      }
      if (this.$route.query.q) {
        this.filterLabels.push('filtrada por ' + this.$route.query.q)
      }
      if (this.$route.query.idFile) {
        let _self = this
        let fileName = this.filesUploaded.filter(function (elem) {
          if (elem.id_file === parseInt(_self.$route.query.idFile)) {
            return elem.name
          }
        })
        this.filterLabels.push('do arquivo ' + fileName[0].name)
      }
      if (this.$route.query.onlyFailedFromLastTransfer) {
        this.filterLabels.push('com falhas, da ultima transferência')
      }
    },
    openLoadingModal () {
      this.$refs.loading.open()
    },
    closeLoadingModal () {
      this.$refs.loading.close()
    },
    controlsOpenModalWithDeletetion () {
      this.$refs.deleteModal.open()
      this.$analytics.pushAnalyticsEvent('ga-event', {
        'category': 'Listagem de OS - Listagem',
        'action': 'Deletar OS - seleção',
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    },
    closeConfirmDeleteOrder () {
      this.$refs.deleteModal.close()
    },
    submitEventForAnalytics (action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        'category': 'Listagem de OS - Listagem',
        'action': action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    },
    transferFromPatientView (os) {
      this.orderSelected = []
      if (Array.isArray(os)) {
        this.orderSelected = os
      } else {
        this.orderSelected.push(os)
      }
      this.validateBeforeTransfering()
    }
  },
  computed: {
    ...mapGetters(['orderLoadingStatus']),
    ...mapGetters(['errorOrders']),
    ...mapGetters(['hasOrders']),
    ...mapGetters(['loading']),
    ...mapGetters(['profile']),
    ...mapGetters(['orders']),
    ...mapGetters(['ordersBreakStatus']),
    ...mapGetters(['errorOrders']),
    ...mapGetters(['filesUploaded']),
    ...mapGetters(['preference']),
    ...mapGetters(['totalOrdersExamsWithDocumentsPending']),
    ...mapGetters(['toggle']),
    ...mapGetters(['isTutorialRead']),
    isSpinnerEnabled () {
      return this.pendingOs === 0
    },
    patientLink () {
      let query = null
      if (this.toggle.profileExam) {
        if (this.orderSelected.length === 1) {
          query = this.isTutorialRead ? '/print-tag/samples?' : '/print-tag/batches?'
          let order = this.orders.filter((obj) => {
            return obj.id === this.orderSelected[0]
          })
          let q = order[0].patient.name
          q = q.replace(/[%¨!@#$&*()+=\\-_]/gi, '')
          query = query.concat('patientName=' + q)
          let date = new Date()
          query = query.concat(
            '&startDate=' +
            formatDate(date, 4) +
            '&endDate=' +
            formatDate(date, 4)
          )
          query = query + '&dateType=TD&orderBy=OSID'
        }
      }
      return query
    }
  },
  watch: {
    orderLoadingStatus: function (newValue) {
      if (newValue === 'STATUS_FAILED' && !this.ordersBreakStatus) {
        notify({
          title: 'AVISO:',
          message: 'Erro ao carregar informações. Por favor, tente novamente.',
          action: {
            title: 'RECARREGAR',
            handler: this.reload
          }
        })
      }
    },
    $route (to, from) {
      this.selectOSList(this.$route.query)
      this.getTotalOrder()
      this.buildFilterLabel()
    },
    errorOrders: function (newValue) {
      this.showHideSnackBarValidator()
    },
    orders: function (newValue) {
      this.countTotalOrdersWithDocPending()
    }
  },
  beforeDestroy () {
    this.$tours['pageTour'].stop()
    this.closeSnackbar()
    this.clearAllOrderData()
    this.orderSelected = []
    this.transfering = true
    resetSortSvgStatus()
  },
  mounted () {
    this.selectOSList(this.$route.query)
    this.$nextTick(function () {
      this.showHideSnackBarValidator()
    })
    this.buildFilterLabel()
  }
}
</script>

<style lang="scss">
@import "../../../static/stylesheets/variables";
@import "../../../static/stylesheets/mixins";
@import "../../../static/stylesheets/components/orders/empty-cart";

.orders-main-view {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  height: $contentContainerHeight;
  padding-top: $mainHeaderHeight;

  .sort-icon {
    position: absolute;
  }

  .subheader-actions-search {
    display: flex;
  }

  .subheader_container .subheader-actions-container__turn-back {
    margin: auto 0 auto auto;
  }

  .orders-list-bar {
    height: 75px;
    position: fixed;
    left: 0;
    background: #ebebeb;
    width: $contentContainerWidth;
    z-index: 2;
    display: inline-flex;

    .multiselect__select {
      &::before {
        display: none;
      }
    }

    .md-gutter-30 {
      &:not(.md-column) {
        margin-right: -15px;
        margin-left: -15px;

        > .md-layout {
          padding-right: 15px;
          padding-left: 15px;
        }
      }
    }

    &__button-container {
      display: flex;
      margin-top: 14px;
      flex-flow: row-reverse;
    }

    &__btn-send {
      width: 183px;

      span {
        margin-left: 0.5em;
      }

      &__icon {
        margin: 0 10px 0 0;
        width: 11px;
        height: 11px;
        min-width: 11px;
        min-height: 11px;
      }
    }

    &__btn-delete {
      position: relative;

      span {
        margin-left: 0.2em;
      }

      &__icon {
        height: 34px;
        width: 32px;
      }
    }

    &__btn-add {
      width: 183px;
      margin-right: 20px;
      font-weight: 500;
      order: 1;

      &__icon {
        margin: 0 10px 0 0;
        width: 16px;
        height: 16px;
        min-width: 16px;
        min-height: 16px;
      }
    }
  }

  .orders-list-bar-delete {
    margin-top: 45px;
    position: fixed;
    z-index: 2;

    .md-gutter-30 {
      &:not(.md-column) {
        margin-right: -15px;
        margin-left: -15px;

        > .md-layout {
          padding-right: 15px;
          padding-left: 15px;
        }
      }
    }

    &__button-container {
      display: flex;
      margin-top: 14px;
      flex-flow: row-reverse;
    }
  }

  .styled-checkbox label {
    border-color: #cacaca;
  }

  .empty-cart {
    margin: 0 auto;
    .actions {
      .md-button {
        width: 204px;
      }
    }
  }
}

.send-orders {
  &.modals .md-dialog {
    min-width: 660px;
    min-height: 230px;

    p {
      display: flex;
      justify-content: center;
      flex-direction: column;
      font-size: 18px;
      letter-spacing: -0.2px;
      text-align: center;
      color: #303030;
      margin-bottom: 10px;
    }
  }
}

.switch-modal {
  &.modals .md-dialog {
    min-width: 660px;
  }

  .md-gutter-40:not(.md-column) > .md-layout {
    padding-right: 15px;
    padding-left: 15px;
  }

  p {
    text-align: center;
    font-size: 18px;
    padding: 20px 0 60px;
  }

  .deletetion-text {
    text-align: center;
    font-size: 18px;
    padding: 0px;
  }
}

.width-right {
  right: 2.7em;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}

.md-dialog-content-spinner {
  margin-top: 1em;
  overflow: unset !important;
}

.larger-modal {
  &.modals .md-dialog {
    width: 660px !important;
    max-width: 660px !important;
    min-height: 230px !important;
  }
}
.medium-modal {
  &.modals .md-dialog {
    width: 480px !important;
    max-width: 480px !important;
  }
}
.transfer-terms-modal {
  font-family: 'Exo 2', sans-serif;
  .md-dialog {
    max-height: 100% !important;
  }
  .md-dialog-title {
    margin: 15px 0 4px 0;
  }
  .close-button {
    top: 10px;
    right: 20px;
  }
  .main-title {
    font-weight: bold;
    font-size: 19px;
    color: #464646;
    .icon-doc-title {
      margin: -3px 10px 0 0;
      path, line {
        stroke:#7F1A54;
      }
    }
  }
}
</style>